module.exports = __webpack_public_path__ + "img/scene1copy02.e13050e9.png";